import React from 'react';
import styled from 'styled-components';
import { Colors, Metrics, Text, Accordion, Link } from '@origin-digital/style-guide';
import { Box } from '@origin-digital/layout';
import { ResponsiveLayout } from '../../../../components/ResponsiveLayout';
import calculator from '../../content.json';

const Disclaimer = styled.div`
  background: ${Colors.WHITE};

  a {
    font-size: ${Metrics.FontSizes.SMALL}px;
  }

  .textItem {
    max-width: 100%;
  }
`;

const Spacer = styled.div`
  height: ${Metrics.Spacing.P_Y_XS}px;
`;

interface ICalculatorDisclaimerState {
  openAccordion: boolean;
}

export class CalculatorDisclaimer extends React.Component<{}, ICalculatorDisclaimerState> {
  private scrollMarker: React.RefObject<HTMLSpanElement>;

  public constructor(props: {}) {
    super(props, {});
    this.scrollMarker = React.createRef();
    this.state = {
      openAccordion: false
    };
  }

  public scrollTo() {
    const markerSpan = this.scrollMarker.current;
    if (markerSpan) {
      this.toggleAccordion();
      window.scroll(0, markerSpan.offsetTop);
    }
  }

  public render() {
    return (
      <React.Fragment>
        <Disclaimer>
          <ResponsiveLayout min={['SM', 'MD', 'LG']}>
            <Box marginLeft={4} marginRight={4}>
              <div ref={this.scrollMarker}>
                <Spacer />
                <Accordion
                  label={calculator.disclaimer.title}
                  open={this.state.openAccordion}
                  onToggle={this.toggleAccordion}
                >
                  {calculator.disclaimer.descriptions.map((section: any) => (
                    <Text key={section} overflow="normal" size="xs" color="grey80" markdown>
                      {section}
                    </Text>
                  ))}
                  <Text overflow="normal" size="xs" color="grey80" markdown>
                    {`The recommended system and costs assume roof orientation of north and a roof pitch
                    (angle) of 30 degrees. To get your property system-ready, additional expenses like
                    electrical works, cabling or roof repairs might be required. We won't know what
                    these are until an installer visits your property. For more information, see our `}
                    <Link
                      href={`https://www.originenergy.com.au/content/dam/origin/residential/solar/Solar%20Installation%20&%20System%20Ready%20Brochure%2007.06.18.pdf?logActivity=true`}
                    >
                      Installation and System Ready Brochure
                    </Link>
                    {`. Potential savings on the electricity bill and payback estimations include GST,
                    and don't take into account any maintenance or inverter replacement costs that you
                    may incur during the product's lifetime.`}
                  </Text>
                </Accordion>
                <Spacer />
              </div>
            </Box>
          </ResponsiveLayout>
        </Disclaimer>
        <Spacer />
      </React.Fragment>
    );
  }

  private toggleAccordion = () => {
    this.setState({ openAccordion: !this.state.openAccordion });
  };
}
